var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"work-header-search-field",on:{"click":_vm.handleSearchBarClick}},[_c('Searchbar',{attrs:{"show-field":_vm.activeModule.isSearchable,"has-expert-search":_vm.activeModule.hasExpertSearch,"place-holder":_vm.searchbarPlaceholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }